import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SettingsContext = createContext(null);

export const cleanPhoneForWhatsApp = (raw, defaultNumber = '573012280877') => {
  if (!raw) return defaultNumber;
  const digits = String(raw).replace(/\D/g, '');
  if (!digits) return defaultNumber;
  if (digits.length === 10) return `57${digits}`;
  return digits;
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchSettings = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/settings/public`);
      setSettings(data || {});
    } catch (err) {
      console.error('Error fetching public settings:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchSettings();
  }, [fetchSettings]);

  const whatsappNumber = cleanPhoneForWhatsApp(
    settings?.whatsapp_phone || settings?.phone,
    '573012280877'
  );

  const whatsappFloatingNumber = cleanPhoneForWhatsApp(
    settings?.whatsapp_floating_phone || settings?.whatsapp_phone || settings?.phone,
    '573012280877'
  );

  return (
    <SettingsContext.Provider
      value={{
        settings,
        whatsappNumber,
        whatsappFloatingNumber,
        refreshSettings: fetchSettings,
        loading,
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    return {
      settings: null,
      whatsappNumber: '573012280877',
      whatsappFloatingNumber: '573012280877',
      refreshSettings: () => {},
      loading: false,
    };
  }
  return context;
};
